import { gql } from '@apollo/client';

export default gql`
  query getOpeningBalances(
    $customerId: String
    $supplierId: String
    $accountId: String
  ) {
    getOpeningBalances(
      customerId: $customerId
      supplierId: $supplierId
      accountId: $accountId
    ) {
      ok
      error
      count
      data {
        _id
        branch
        autoNo
        docNo
        opType
        time
        title
        desc

        contractId
        contractName
        contractNameAr

        projectId
        projectName
        projectNameAr

        customerId
        customerName
        customerNameAr
        customerPhone

        supplierId
        supplierName
        supplierNameAr
        supplierPhone

        accountId
        accountName
        accountNameAr

        employeeId
        employeeName
        employeeNameAr
        employeeColor

        refNo
        refType

        amount

        debitAcc
        debitAccName
        debitAccNameAr
        creditAcc
        creditAccName
        creditAccNameAr

        chequeBank
        chequeNo
        chequeDate

        procs

        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
